import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

document.addEventListener('DOMContentLoaded', function () {
    gsap.registerPlugin(ScrollTrigger);

    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: ".timeline-section",
            start: "top 15%", // La section s'épingle quand elle atteint le haut de l'écran (avec une petite marge)
            end: "+=200%", // Définit le "temps de lecture" : la section reste épinglée sur une distance équivalente à 2 fois la hauteur de l'écran
            pin: true, // Garde la section fixe pendant qu'on scrolle
            scrub: 1, // Lie l'animation au scroll avec un léger lissage (1 seconde) pour que ce soit fluide
        }
    });

    // Note : Avec "scrub", la notion de "duration" en secondes disparaît.
    // Le temps est calculé en fonction de la distance de défilement.

    // 1. Animation de l'image de l'équipe
    tl.from(".timeline-image", {
        x: -50,
        opacity: 0,
        ease: "none" // "none" est souvent plus naturel quand on utilise "scrub"
    });

    // 2. Animation des blocs de texte en cascade
    tl.from(".timeline-item", {
        y: 30,
        opacity: 0,
        stagger: 0.5, // Crée l'effet de cascade au fur et à mesure qu'on scrolle
        ease: "none"
    });

    // 3. Petit effet de focus sur les numéros
    tl.from(".timeline-number", {
        scale: 0.5,
        opacity: 0,
        stagger: 0.5,
        ease: "back.out(1.7)"
    }, "<"); // Aligné avec le début des blocs
});